import { get, patch, post, httpDelete } from '../../utils/http';

export const fetchTimesheetFields = ({ accountId }) => get(`/accounts/${accountId}/timesheet-fields`);

export const addTimesheetField = ({ accountId, field }) => post(`/accounts/${accountId}/timesheet-fields`, field);

export const updateTimesheetField = ({ accountId, fieldId, field }) =>
  patch(`/accounts/${accountId}/timesheet-fields/${fieldId}`, field);

export const deleteTimesheetField = ({ accountId, fieldId }) =>
  httpDelete(`/accounts/${accountId}/timesheet-fields/${fieldId}`);
